<template>
    <component
            :is="currentFieldComponent(reply.field.type)"
            v-if="!isFieldEmpty(reply)"
            :reply="reply" />
</template>

<script>
    import {
        TYPE_TEXT,
        TYPE_TEXTAREA,
        TYPE_CHECKBOX,
        TYPE_PHOTO,
        TYPE_SIGNATURE,
        TYPE_DATETIME,
        TYPE_HTML,
        TYPE_SELECT,
        TYPE_DRAWING,
        TYPE_TIPS,
        TYPE_PAYMENT_METHOD
    } from "@/models/field.model"
    import FieldTextReply from "./components/FieldTextReply"
    import FieldOptionsReply from "./components/FieldOptionsReply"
    import FieldSignatureReply from "./components/FieldSignatureReply"
    import FieldHtmlReply from "./components/FieldHtmlReply"
    import FieldDatetimeReply from "./components/FieldDatetimeReply"
    import FieldPhotoReply from "./components/FieldPhotoReply"
    import FieldTextareaReply from "./components/FieldTextareaReply";
    import FieldDrawingReply from "@/views/Reply/components/components/FieldDrawingReply";
    import FieldTipsReply from "@/views/Reply/components/components/FieldTipsReply.vue";
    import FieldPaymentMethodReply from "@/views/Reply/components/components/FieldPaymentMethodReply.vue";
	
    export default {
        name: "FieldReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
        methods: {
            isFieldEmpty(consumerField) {
                if (consumerField.field_payment_method) {
                    return !consumerField.field_payment_method.name;
                }
                if (consumerField.field_tips) {
                    return !consumerField.field_tips.amount || !consumerField.field_tips.currency;
                }
                if (consumerField.field_options) {
                    return consumerField.field_options.filter(e => e.field_option !== null).length < 1;
                }
                if (consumerField.field_datetime) {
                    return consumerField.field_datetime.value === null;
                }
                if (consumerField.field_photo) {
                    return consumerField.field_photo.filter(e => e.value !== null).length < 1;
                }
                if (consumerField.field_drawing) {
                    return !consumerField.field_drawing.value;
                }
                if (consumerField.field_text) {
                    return consumerField.field_text.value === null;
                }
                if (consumerField.field_textarea) {
                    return consumerField.field_textarea.value === null;
                }
                return false;
            },
            currentFieldComponent(type) {
                switch (type) {
                case TYPE_TEXT:
                    return FieldTextReply;
                case TYPE_TEXTAREA:
                    return FieldTextareaReply;
                case TYPE_CHECKBOX:
                case TYPE_SELECT:
                    return FieldOptionsReply;
                case TYPE_SIGNATURE:
                    return FieldSignatureReply;
                case TYPE_HTML:
                    return FieldHtmlReply;
                case TYPE_DATETIME:
                    return FieldDatetimeReply;
                case TYPE_PHOTO:
                    return FieldPhotoReply;
                case TYPE_DRAWING:
                    return FieldDrawingReply;
                case TYPE_TIPS:
                    return FieldTipsReply;
                case TYPE_PAYMENT_METHOD:
                    return FieldPaymentMethodReply;
                default:
                    return null;
                }
            }
        }
    }
</script>

<style scoped>

</style>